export const Globe = () => (
  <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_12242_19960)">
      <mask id="mask0_12242_19960" style={{maskType: "luminance"}} maskUnits="userSpaceOnUse" x="0" y="0" width="48" height="48">
        <g opacity="0.8">
          <path d="M24.0014 4C18.8161 4 14.5525 11.8934 14.0508 22H33.952C33.4503 11.8934 29.1868 4 24.0014 4Z" fill="white"/>
          <path d="M24.0014 44C18.8161 44 14.5525 36.1066 14.0508 26H33.952C33.4503 36.1066 29.1868 44 24.0014 44Z" fill="white"/>
        </g>
        <g opacity="0.6">
          <path d="M39.9201 22H33.9498C33.448 11.8934 29.1845 4 23.9991 4C32.2957 4 39.1174 11.8934 39.9201 22Z" fill="white"/>
          <path d="M23.9991 4C18.8138 4 14.5502 11.8934 14.0485 22H8.07812C8.88088 11.8934 15.7026 4 23.9991 4Z" fill="white"/>
          <path d="M23.9991 44C15.7026 44 8.88088 36.1066 8.07812 26H14.0485C14.5502 36.1066 18.8138 44 23.9991 44Z" fill="white"/>
          <path d="M23.9991 44C29.1845 44 33.448 36.1066 33.9498 26H39.9201C39.1174 36.1066 32.2957 44 23.9991 44Z" fill="white"/>
        </g>
        <g opacity="0.4">
          <path d="M23.9989 4C15.7023 4 8.88066 11.8934 8.07791 22H4.09766C5.10111 11.8934 13.6282 4 23.9989 4Z" fill="white"/>
          <path d="M23.9989 4C34.3696 4 42.8967 11.8934 43.9002 22H39.9199C39.1171 11.8934 32.2955 4 23.9989 4Z" fill="white"/>
          <path d="M23.9989 44C34.3696 44 42.8967 36.1066 43.9002 26H39.9199C39.1171 36.1066 32.2955 44 23.9989 44Z" fill="white"/>
          <path d="M23.9989 44C15.7023 44 8.88066 36.1066 8.07791 26H4.09766C5.10111 36.1066 13.6282 44 23.9989 44Z" fill="white"/>
        </g>
      </mask>
      <g mask="url(#mask0_12242_19960)">
        <rect width="48" height="48" fill="#E54796"/>
      </g>
    </g>
    <defs>
      <clipPath id="clip0_12242_19960">
        <rect width="48" height="48" fill="white"/>
      </clipPath>
    </defs>
  </svg>
)
